const isExpiredAssignment = assignment =>
    Boolean(assignment) && Date.parse(assignment.expires_at) <= Date.now()

export const hasOrderNum = assignment =>
    assignment?.order_num !== undefined && assignment?.order_num !== null

export const withOrderNum = (incoming, current) => {
    if (!incoming) return null
    if (!current || !hasOrderNum(current)) return incoming
    if (current.assignment_id !== incoming.assignment_id) return incoming
    if (hasOrderNum(incoming)) return incoming

    return { ...incoming, order_num: current.order_num }
}

export default {
    APPLY_STATE(state, { enabled, stateVersion, assignment = null }) {
        if (stateVersion < state.stateVersion) return

        state.enabled = enabled
        state.stateVersion = stateVersion
        const restored = isExpiredAssignment(assignment) ? null : assignment
        state.assignment = withOrderNum(restored, state.assignment)
    },

    APPLY_STATUS(state, { enabled, stateVersion }) {
        if (stateVersion <= state.stateVersion) return

        state.enabled = enabled
        state.stateVersion = stateVersion
        if (!enabled) state.assignment = null
    },

    SET_ASSIGNMENT(state, assignment) {
        state.assignment = withOrderNum(assignment, state.assignment)
    },

    CLEAR_ASSIGNMENT(state) {
        state.assignment = null
    },

    RESET_STATE(state) {
        state.enabled = false
        state.stateVersion = -1
        state.assignment = null
    },
}
